import { UploadFilesModal, HiddenButton } from "../../../../../Constants/StyledComponents"
import ModalHeader from "../../../../../Components/ModalHeader/ModalHeader"
import { useUploadProcessProvider } from "../../../../../Providers/UploadProcessProvider"
import { ModalFooter } from "../../../../../Constants/StyledComponents"
import ModalScrollbar from "../../../../../Components/ModalScrollbar/ModalScrollbar"
import { UploadStepHeader } from "../../../../../Constants/StyledComponents";
import ModernMUITable from "../../../../../Components/ModernMUITable"
import { useAuthProvider } from "../../../../../Providers/AuthProvider"
import { useState, useEffect } from "react"
import { MobergButton } from "../../../../../Components/MobergButton/MobergButton";
import { MobergTheme } from "../../../../../Components/MobergThemes/MobergColors";
import { MobergButtonVariant } from "../../../../../Components/MobergButton/MobergButton";
import { MobergButtonShape } from "../../../../../Components/MobergButton/MobergButton";
// import { Scrollbar } from "../../../../../Constants/StyledComponents"
import { useBackendLinksProvider } from "../../../../../Providers/BackendLinksProvider"
import { useEnvironmentVariablesProvider } from "../../../../../Providers/EnvironmentVariablesProvider"
import { useFetchTableData } from "../../../../../Hooks/useFetchTableData"

const siteColumns = [
	{ field: "identifier", flex: 0.4, headerName: "Site ID", minWidth: 100, visible: true },
	{ field: "name", flex: 1, headerName: "Site name", visible: true },
	{ field: "description", flex: 1, headerName: "Description", visible: true },
	{ field: "location", flex: 1, headerName: "Location", visible: true },
	{ field: "user_count", flex: 0.4, headerName: "No. users", minWidth: 100, visible: true },
	{ field: "patient_count", flex: 0.4, headerName: "No. patients", minWidth: 120, visible: true },
]

const UploadSiteDetail = ({ setToNextWindow, setToPrevWindow }) => {
	const uploadProcessProvider = useUploadProcessProvider()
	const authProvider = useAuthProvider()
	const { LINKS } = useBackendLinksProvider()
	const environmentVariablesProvider = useEnvironmentVariablesProvider()

	const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 })
	const [sortModel, setSortModel] = useState([{ field: 'identifier', sort: 'asc' }])

	const handleBack = () => {
		setToPrevWindow(true)
	}

	const handleNext = () => {
		setToNextWindow(true)
	}

	// Fetch current page's site data to support selection
	const { data: sitesData } = useFetchTableData({
		queryKey: "project_user_sites",
		endpoint: LINKS.DATA.UPLOAD.GET_PROJECT_USER_SITES,
		body: { user_id: authProvider.currentUser?.id },
		queryOptions: {},
		paginationModel,
		sortModel,
		supportsPageSize: true
	})

	const sitesById = (sitesData?.data || []).reduce((acc, site) => {
		acc[site.id] = site
		return acc
	}, {})

	const [selectedRows, setSelectedRows] = useState([])
	
	// Auto-select when there's only one site (check from total count)
	useEffect(() => {
		if (sitesData?.total === 1 && sitesData?.data?.length === 1) {
			// Auto-select the only site
			const onlySite = sitesData.data[0]
			setSelectedRows([onlySite.id])
			uploadProcessProvider.setSelectedSiteID(onlySite.identifier)
			uploadProcessProvider.setSelectedSitePrimaryKey(onlySite.id)
			uploadProcessProvider.setSelectedSiteName(onlySite.name)
		} else {
			// Reset to previous selections if they exist, otherwise clear
			if (uploadProcessProvider?.selectedSitePrimaryKey && uploadProcessProvider?.selectedSitePrimaryKey !== '') {
				setSelectedRows([uploadProcessProvider.selectedSitePrimaryKey])
			} else {
				setSelectedRows([])
			}
		}
	}, [sitesData, uploadProcessProvider])

	// Handle site selection change - with server-side pagination, get site info from current page data
	const handleSiteSelectionChange = (selectionArray) => {
		setSelectedRows(selectionArray);
		
		if (selectionArray.length === 0) {
			// Clear selection
			uploadProcessProvider.setSelectedSiteID("");
			uploadProcessProvider.setSelectedSitePrimaryKey("");
			uploadProcessProvider.setSelectedSiteName("");
		} else {
			// Get site from current page's data
			const selectedId = selectionArray[0];
			const selectedSite = sitesById[selectedId];
			
			if (selectedSite) {
				handleCheckboxSelectionChange(selectedSite, true);
			}
		}
	}

	function handleCheckboxSelectionChange(site, isClicked) {
		uploadProcessProvider.resetExistingTableData()
		if (site["identifier"] !== uploadProcessProvider.selectedSiteID) {
			if (!uploadProcessProvider.checkFoldersIsEmpty()) {
				if (window.confirm("Modifying existing site ID will remove your previously selected upload files. Do you want to continue?")) {
					uploadProcessProvider.resetTableData()
					uploadProcessProvider.resetUploadFolders()
					uploadProcessProvider.resetDirectoryNames()
				} else return
			}
		}

		uploadProcessProvider.setSelectedSiteID(isClicked ? site["identifier"] : "")
		uploadProcessProvider.setSelectedSitePrimaryKey(isClicked ? site["id"] : "")
		uploadProcessProvider.setSelectedSiteName(isClicked ? site["name"] : "")
	}

	return (
		<>
			<UploadFilesModal id="uploadFilesButtonModal">
				<ModalHeader headerText="Select a Site" resetCache={uploadProcessProvider.resetCache} />
				<ModalScrollbar>
					<div style={{ marginBottom: "24px" }}>
						<UploadStepHeader>1. Select the site where the patient was admitted</UploadStepHeader>
					</div>
					<ModernMUITable 
						columns={siteColumns} 
					queryKey="project_user_sites"
					endpoint={LINKS.DATA.UPLOAD.GET_PROJECT_USER_SITES}
					body={{ user_id: authProvider.currentUser?.id }}
					optionalParams={{}}
					paginationModel={paginationModel}
					onPaginationModelChange={setPaginationModel}
					sortModel={sortModel}
					onSortModelChange={setSortModel}
					paginationMode="server"
					sortingMode="server"
						enableRowSelection={true}
						checkboxSelection={true}
					supportsPageSize={true}
						onSelectionChange={handleSiteSelectionChange}
						rowSelectionModel={{ type: 'include', ids: new Set(selectedRows) }}
						isRowSelectable={() => true}
						disableRowSelectionOnClick={false}
						disableSelectAll={true}
					showToolbar={true}
						height="90%"
						style={{ padding: '10px' }}
					/>
				</ModalScrollbar>

				<hr style={{ border: "1px solid var(--color-border-default)", width: "100%", margin: '0px auto' }} />
				<ModalFooter>
					{environmentVariablesProvider.environmentVariables.PHI_WARNING ? (
						<MobergButton
							theme={MobergTheme.BLUE}
							variant={MobergButtonVariant.OUTLINE}
							shape={MobergButtonShape.WIDE}
							onClick={handleBack}
						>
							Back
						</MobergButton>
					) : (
						<HiddenButton />
					)}

					<MobergButton
						theme={MobergTheme.BLUE}
						variant={MobergButtonVariant.FILLED}
						shape={MobergButtonShape.WIDE}
						onClick={handleNext}
						disabled={uploadProcessProvider.selectedSiteID === ''}
					>
						Next
					</MobergButton>
				</ModalFooter>
			</UploadFilesModal >
		</>
	)
}

export default UploadSiteDetail